import type { LeaderboardEntry } from "../metrics.ts";

export type TopPerformerProps = {
  /** Đã sort sẵn bởi leaderboard() — phần tử đầu là top. */
  leaderboard: readonly LeaderboardEntry[];
  /** "all-time" hoặc "JUN 21, 2026 → JUL 19, 2026". app.js tính từ filter
   *  hiện tại; component không đọc state để còn test/tái dùng được. */
  scope: string;
};

export function TopPerformer({ leaderboard, scope }: TopPerformerProps) {
  const top = leaderboard[0];

  // 0 offer thì không tôn ai làm top — số 0 xếp trên cùng vẫn là 0.
  if (!top || top.offers === 0) {
    return (
      <>
        <span className="tp-tag">👑 TOP PERFORMER</span>
        <p style={{ opacity: 0.85 }}>No offers under current filters yet.</p>
      </>
    );
  }

  return (
    <>
      <span className="tp-tag">👑 TOP PERFORMER</span>
      <div className="tp-row">
        <div className="tp-avatar">👑</div>
        <div>
          <div className="tp-name">{top.recruiter}</div>
          <div className="tp-desc">Most offers made {scope}</div>
        </div>
      </div>
      <div className="tp-stats">
        <div><div className="label">OFFERS</div><div className="num">{top.offers}</div></div>
        <div><div className="label">CANDIDATES CONTACTED</div><div className="num">{top.intake}</div></div>
      </div>
    </>
  );
}
